import { useNavigate } from 'react-router-dom';
import { Title } from '../../Components/Atoms';
import { Donut } from '../../Components/Organisms/Graphs';
import { ArrowRightIcon, VehicleIcon } from '../../Assets/images/svgs';
import { WidgetLegend } from '../../Components/Atoms';
import { Button } from '@chakra-ui/react';
import PATHS from "../../Routes/paths";
import { MODEL_COLORS } from '../../Assets/styles/colors';
import NoDataWidget from '../NoDataWidget';
import { useMemo } from 'react';

const VehiclesUnitStat = ({ data }) => {
  const Navigate = useNavigate();
  const parser = { x: "label", y: "count" };

  const graphData = useMemo(() => {
    if (data && data.vehicleStats) {
      data.vehicleStats.sort((a, b) => b.count - a.count);
      let newData = [...data.vehicleStats];

      if (data.vehicleStats.length > 4) {
        newData = newData.slice(0, 3);
        
        let count = data.vehicleStats.slice(3,).reduce((acc, data) => acc + data.count, 0);
        newData.push({ mo: "Others", count: count });
      }

      return newData.map((d, idx) => ({ label: d.mo, count: d.count, color: MODEL_COLORS[idx] }));
    }
    else
      return [];
  }, [data]);
  const total = graphData.reduce((acc, item) => acc + item.count, 0)

  return (
    <div className="widget-group widget-1 unit-widget">
      {
        graphData.length ?
          <article className="widget-main">
            <header className="widget-header">
              <Title variant="md" fixed>Vehicles</Title>
            </header>

            <main className="widget-section">
              <div className="widget-chart">
                <Donut title="Vehicles" data={graphData} parser={parser} />
                <span className="widget-chart-text">
                  <span className="total">{total}</span>
                  <span className="units">Units</span>
                </span>
              </div>

              <div className="widget-legend">
                <WidgetLegend sparse data={graphData} parser={parser} showPercent={false} doSort={false} />
              </div>
              <div className="widget-link">
                <Button variant={"ghost"} rightIcon={<ArrowRightIcon />} onClick={() => Navigate(PATHS.VEHICLES)}>
                  View Reports
                </Button>
              </div>
            </main>
          </article> : <NoDataWidget
            heading={"Vehicles"}
            showBtn="true"
            icon={VehicleIcon}
            info="No vehicles available"
            btnTitle={"Add New vehicle"}
            onClick={() => Navigate(PATHS.ADDVEHICLE)}
          />
      }
    </div>
  );
}

export default VehiclesUnitStat;